/**
 * Truncates a description string to a maximum length.
 * If the string exceeds maxLength, it is cut at maxLength characters
 * and "...more" is appended.
 *
 * @param text - The description text to truncate
 * @param maxLength - Maximum characters before truncation (default: 200)
 * @returns The original text if within limit, or truncated text with "...more" appended
 */
export function truncateDescription(text: string, maxLength: number = 200): string {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + '...more';
}
